import styled from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';

export const PhotosWrapper = styled.div`
  display: grid;
  gap: 15px;
  height: fit-content;
  grid-template-columns: repeat(
    auto-fill,
    minmax(calc((100% / 3) - 15px), 1fr)
  );

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    grid-template-columns: repeat(
      auto-fill,
      minmax(calc((100% / 4) - 15px), 1fr)
    );
  }
`;

export const PhotosOuterWrapper = styled(FlexColumn)`
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 30px;
  }
`;
